import { FC } from 'react'
import { DetailField, DetailFields, DetailPanel } from '../../../../../../components'
import {
  AtendimentoReport,
  FuncionarioReport,
} from '../../../../meus-atendimentos/meus-atendimentos-list/core/_models'

type IProps = {
  data: AtendimentoReport
  isLoading?: boolean
}

export const RelatorioExpandedRow: FC<IProps> = ({ data, isLoading }) => {
  // Profissional com o vínculo como linha de apoio.
  const profissional = (label: string, funcionario?: FuncionarioReport) => (
    <DetailField label={label} value={funcionario?.nome} detail={funcionario?.vinculo} />
  )

  return (
    <DetailPanel isLoading={isLoading} loadingLabel='Carregando detalhes do atendimento…'>
      {data && (
        <DetailFields>
          <DetailField label='Solicitante' value={data.criador?.nome} />
          {profissional('Profissional iniciou', data.responsavelInicial)}
          {profissional('Profissional finalizou', data.responsavel)}
          <DetailField label='Contrato' value={data.empresa?.contrato} />
          <DetailField label='Início' value={data.inicioFormatado} />
          <DetailField label='Término' value={data.terminoFormatado} />
          <DetailField
            label='Motivo do cancelamento'
            value={data.motivoCancelamento}
            emptyLabel='Sem cancelamento'
            wide
          />
        </DetailFields>
      )}
    </DetailPanel>
  )
}
